import m from "mithril";
import { getMithril, showToast } from "../utils.js";

var CoordViewCustomer = {
    oninit: function(vnode) {
        this.customer = null;
        this.isLoading = false;
        this.error = null;
        // Fix: Get customer ID from route parameters
        this.customerId = m.route.param("id");

        if (this.customerId) {
            this.fetchCustomer(this.customerId);
        } else {
            this.error = "ID nasabah tidak ditemukan";
        }
    },

    fetchCustomer: async function(customerId) {
        try {
            this.error = null;

            // Instead of trying to fetch a specific customer by ID,
            // fetch all customers and filter for the specific one
            const response = await getMithril(`/api/customers`, { component: this });

            // Find the customer with the matching ID
            const customer = response.data.find(c => c.id == customerId);
            if (customer) {
                this.customer = customer;
            } else {
                throw new Error("Nasabah tidak ditemukan");
            }
        } catch (error) {
            console.error("Error fetching customer:", error);
            this.error = error.message;
            showToast("Gagal memuat data nasabah: " + error.message, "error");
        }
    },

    goBack: function() {
        // Navigate back to customers list
        m.route.set('/coord-customers');
    },

    view: function(vnode) {
        return m("div", { class: "p-6" }, [
            m("div", { class: "mb-6 flex items-center" }, [
                m("button", {
                    class: "flex items-center text-orange-600 hover:text-orange-800 dark:text-orange-400 dark:hover:text-orange-300 mr-4",
                    onclick: () => this.goBack()
                }, [
                    m("i", { class: "ri-arrow-left-line mr-1" }),
                    "Kembali"
                ]),
                m("h2", { class: "text-2xl font-bold text-gray-800 dark:text-white" }, "Detail Nasabah")
            ]),

            // Loading indicator
            this.isLoading ? m("div", { class: "flex justify-center items-center h-64" }, [
                m("div", { class: "text-center" }, [
                    m("i", { class: "ri-loader-4-line animate-spin text-3xl text-orange-500 mb-4 block" }),
                    m("p", { class: "text-gray-600 dark:text-gray-300" }, "Memuat detail nasabah...")
                ])
            ]) : null,

            // Error message
            this.error && !this.isLoading ? m("div", { class: "mb-6 bg-red-50 dark:bg-red-900 border-l-4 border-red-500 p-4 rounded" }, [
                m("div", { class: "flex items-center" }, [
                    m("i", { class: "ri-error-warning-line text-red-500 dark:text-red-300 text-xl mr-3" }),
                    m("div", [
                        m("p", { class: "text-red-700 dark:text-red-200 font-medium" }, "Gagal Memuat Data"),
                        m("p", { class: "text-red-600 dark:text-red-300 text-sm mt-1" }, this.error)
                    ])
                ]),
                m("button", {
                    class: "mt-3 bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm transition-colors duration-200",
                    onclick: () => this.fetchCustomer(this.customerId)
                }, "Coba Lagi")
            ]) : null,

            // Customer details
            !this.isLoading && !this.error && this.customer ? m("div", { class: "space-y-6" }, [
                // Basic Information
                m("div", { class: "bg-white dark:bg-gray-800 rounded-lg shadow p-6" }, [
                    m("h3", { class: "text-lg font-semibold text-gray-800 dark:text-white mb-4" }, "Informasi Dasar"),
                    m("div", { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }, [
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Nama Nasabah"),
                            m("p", { class: "text-gray-900 dark:text-white font-medium" }, this.customer.nama_nasabah)
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Nomor Registrasi"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.no_reg || "-")
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Tanggal Registrasi"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.tgl_reg ? new Date(this.customer.tgl_reg).toLocaleDateString('id-ID') : "-")
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Nomor KTP"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.no_ktp || "-")
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Tempat & Tanggal Lahir"),
                            m("p", { class: "text-gray-900 dark:text-white" }, 
                                this.customer.tempat_lahir && this.customer.tgl_lahir ? 
                                `${this.customer.tempat_lahir}, ${new Date(this.customer.tgl_lahir).toLocaleDateString('id-ID')}` : 
                                "-"
                            )
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Jenis Kelamin"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.jenis_kelamin || "-")
                        ])
                    ])
                ]),

                // Contact Information
                m("div", { class: "bg-white dark:bg-gray-800 rounded-lg shadow p-6" }, [
                    m("h3", { class: "text-lg font-semibold text-gray-800 dark:text-white mb-4" }, "Kontak & Pekerjaan"),
                    m("div", { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }, [
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Nomor Telepon"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.no_telepon || "-")
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Pekerjaan"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.pekerjaan || "-")
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Penghasilan"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.penghasilan ? `Rp ${parseInt(this.customer.penghasilan).toLocaleString('id-ID')}` : "-")
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Status Perkawinan"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.status_kawin || "-")
                        ])
                    ])
                ]),

                // Address Information
                m("div", { class: "bg-white dark:bg-gray-800 rounded-lg shadow p-6" }, [
                    m("h3", { class: "text-lg font-semibold text-gray-800 dark:text-white mb-4" }, "Alamat"),
                    m("div", { class: "space-y-4" }, [
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Alamat Lengkap"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.alamat || "-")
                        ]),
                        m("div", { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }, [
                            m("div", [
                                m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "RT/RW"),
                                m("p", { class: "text-gray-900 dark:text-white" }, 
                                    this.customer.rt && this.customer.rw ? 
                                    `RT. ${this.customer.rt} / RW. ${this.customer.rw}` : 
                                    "-"
                                )
                            ]),
                            m("div", [
                                m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Kelurahan"),
                                m("p", { class: "text-gray-900 dark:text-white" }, this.customer.kelurahan_name || "-")
                            ]),
                            m("div", [
                                m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Kecamatan"),
                                m("p", { class: "text-gray-900 dark:text-white" }, this.customer.kecamatan_name || "-")
                            ]),
                            m("div", [
                                m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Kabupaten/Kota"),
                                m("p", { class: "text-gray-900 dark:text-white" }, this.customer.kota_name || "-")
                            ]),
                            m("div", [
                                m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Provinsi"),
                                m("p", { class: "text-gray-900 dark:text-white" }, this.customer.provinsi_name || "-")
                            ]),
                            m("div", [
                                m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Kode Pos"),
                                m("p", { class: "text-gray-900 dark:text-white" }, this.customer.kode_pos || "-")
                            ])
                        ])
                    ])
                ]),

                // Unit Information
                m("div", { class: "bg-white dark:bg-gray-800 rounded-lg shadow p-6" }, [
                    m("h3", { class: "text-lg font-semibold text-gray-800 dark:text-white mb-4" }, "Unit"),
                    m("div", { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }, [
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Subunit ID"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.subunit_id || "-")
                        ]),
                        m("div", [
                            m("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Nama Subunit"),
                            m("p", { class: "text-gray-900 dark:text-white" }, this.customer.subunit_name || "-")
                        ])
                    ])
                ])
            ]) : null
        ]);
    }
};

export default CoordViewCustomer;